import React, { useEffect, useState } from 'react';
import { fetchMovies } from '../api/api';
import MovieCard from './MovieCard';

const CategoryList = ({ category, endpoint }) => {
  const [movies, setMovies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setCurrentPage(1);
    setMovies([]);
  }, [endpoint]);

  useEffect(() => {
    const getMovies = async () => {
      setLoading(true);
      try {
        const data = await fetchMovies(endpoint, currentPage);
        let filteredMovies = data.results;
        
        // Filter upcoming movies based on release date
        if (endpoint.includes('upcoming')) {
          const currentDate = new Date();
          filteredMovies = data.results.filter(movie => {
            const releaseDate = new Date(movie.release_date);
            return releaseDate > currentDate;
          });
        }

        setMovies(filteredMovies);
        setTotalPages(data.total_pages);
      } catch (error) {
        console.error('Error fetching movies:', error);
      }
      setLoading(false);
    };

    getMovies();
  }, [endpoint, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  return (
    <div className="container">
      <h2 className="mb-4">{category}</h2>
      {loading ? (
        <div className="text-center p-5">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="row g-4">
            {movies?.map(movie => (
              <div key={movie.id} className="col-md-3 mb-4">
                <MovieCard movie={movie} />
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-center gap-3 my-4">
            <button 
              className="btn btn-primary"
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Pre
            </button>
            
            <div className="d-flex gap-2 align-items-center">
              {[...Array(Math.min(5, totalPages))].map((_, index) => {
                const pageNumber = currentPage - 2 + index;
                if (pageNumber > 0 && pageNumber <= totalPages) {
                  return (
                    <button
                      key={pageNumber}
                      className={`btn ${currentPage === pageNumber ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  );
                }
                return null;
              })}
            </div>

            <button 
              className="btn btn-primary"
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Nxt
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CategoryList;
